module.exports = __webpack_public_path__ + "img/ast.78070574.svg";